import {PropsWithChildren, useCallback} from 'react';
import {BaseLayoutProps} from '../types';
import {getCustomBaseStyle, getResponsiveHideBaseStyle} from '../functions';
import {useDebugBorders} from './useDebugBorders';
import {useStyleCategories} from '../../base/hooks';
import {BaseLayoutStyleCategories} from '../coreLayout';

export const useBaseLayoutProps = (
  props: PropsWithChildren<BaseLayoutProps>,
) => {
  const {hideWhen, onPress, children, ...rest} = props;

  const handleClick = useCallback(() => {
    onPress && onPress();
  }, [onPress]);

  const debugColorsClassname = useDebugBorders();
  const responsiveStyle = getResponsiveHideBaseStyle(hideWhen);
  const customStyle = getCustomBaseStyle(rest, responsiveStyle);
  const styleClassname = useStyleCategories(
    BaseLayoutStyleCategories,
    rest,
    customStyle,
  );

  const classNameProp =
    debugColorsClassname && styleClassname
      ? {className: `di-div ${debugColorsClassname} ${styleClassname}`}
      : debugColorsClassname || styleClassname
      ? {className: `di-div ${debugColorsClassname || styleClassname}`}
      : {className: 'di-div'};

  return {
    classNameProp,
    handleClick,
    children,
  };
};
